import { PROJECT_BACKLOG } from "../actions/utilities";

const INITIAL_STATE = {
  getProjectBackLogLoading: false,
  getProjectBackLogSuccess: false,
  getProjectBackLogFailure: false,
  getProjectBackLogError: null,

  addProjectBackLogLoading: false,
  addProjectBackLogSuccess: false,
  addProjectBackLogFailure: false,
  addProjectBackLogError: null,

  editProjectBackLogLoading: false,
  editProjectBackLogSuccess: false,
  editProjectBackLogFailure: false,
  editProjectBackLogError: null,

  addTaskInMilestoneLoading: false,
  addTaskInMilestoneSuccess: false,
  addTaskInMilestoneFailure: false,
  addTaskInMilestoneError: null,

  getProjectKanbanLoading: false,
  getProjectKanbanSuccess: false,
  getProjectKanbanFailure: false,
  getProjectKanbanError: null,
  FilterdprojectTask: [],
  FilterdprojectTaskCount: 0,

  deleteProjectBackLogLoading: true,
  deleteProjectBackLogSuccess: false,
  deleteProjectBackLogFailure: false,
  deleteProjectBackLogError: null,
  projectBackLog: [],
  projectBackLogTotalCount: 0,
  moveBackLogLoading: false,
  moveBackLogSuccess: false,
  moveBackLogFailure: false,
  moveBackLogError: null,
};

export const projectBacklogReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case PROJECT_BACKLOG.MOVE_BACKLOG_REQUEST:
      return {
        ...state,
        moveBackLogLoading: true,
        moveBackLogSuccess: false,
        moveBackLogFailure: false,
        moveBackLogError: null,
      };
    case PROJECT_BACKLOG.MOVE_BACKLOG_SUCCESS:
      // let list = state.projectBackLog
      // for (let i = 0; i < list.length; i++) {
      //     if (list.taskId === action.payload) {
      //         list.splice(i, 1)
      //     }
      // }

      // if (action.payload != null) {
      //     for (let index = 0; index < state.projectBackLog.length; index++) {
      //         let hasId = state.projectBackLog[index].taskId === action.payload.taskId;
      //         if (hasId)
      //             state.projectBackLog.splice(index, 1)
      //         state.projectBackLog = [...state.projectBackLog]
      //     }
      // }
      return {
        ...state,
        moveBackLogLoading: false,
        moveBackLogSuccess: true,
        moveBackLogFailure: false,
        moveBackLogError: null,
        // projectBackLog: action.payload,
      };
    case PROJECT_BACKLOG.MOVE_BACKLOG_FAILURE:
      return {
        ...state,
        moveBackLogLoading: false,
        moveBackLogSuccess: false,
        moveBackLogFailure: true,
        moveBackLogError: action.payload,
      };
    //get PROJECT BACKLOG states
    case PROJECT_BACKLOG.GET_PROJECT_BACKLOG_REQUEST:
      return {
        ...state,
        getProjectBackLogLoading: true,
        getProjectBackLogSuccess: false,
        getProjectBackLogFailure: false,
        getProjectBackLogError: null,
      };
    case PROJECT_BACKLOG.GET_PROJECT_BACKLOG_SUCCESS:
      state.projectBackLog = action.payload.records;
      state.projectBackLogTotalCount = action.payload.totalRecords;
      return {
        ...state,
        getProjectBackLogLoading: false,
        getProjectBackLogSuccess: true,
        getProjectBackLogFailure: false,
        getProjectBackLogError: null,
      };
    case PROJECT_BACKLOG.GET_PROJECT_BACKLOG_FAILURE:
      return {
        ...state,
        getProjectBackLogLoading: false,
        getProjectBackLogSuccess: false,
        getProjectBackLogFailure: true,
        getProjectBackLogError: action.payload,
      };

    case PROJECT_BACKLOG.FILTER_TASK_BY_MILESTONE_REQUEST:
      return {
        ...state,
        getProjectKanbanLoading: true,
        getProjectKanbanSuccess: false,
        getProjectKanbanFailure: false,
        getProjectKanbanError: null,
      };
    case PROJECT_BACKLOG.FILTER_TASK_BY_MILESTONE_SUCCESS:
      // state.FilterdprojectTask = action.payload.records
      // state.FilterdprojectTaskCount = action.payload.totalRecords
      return {
        ...state,
        getProjectKanbanLoading: false,
        getProjectKanbanSuccess: true,
        getProjectKanbanFailure: false,
        getProjectKanbanError: null,
        FilterdprojectTask: action.payload,
      };
    case PROJECT_BACKLOG.FILTER_TASK_BY_MILESTONE_FAILURE:
      return {
        ...state,
        getProjectKanbanLoading: false,
        getProjectKanbanSuccess: false,
        getProjectKanbanFailure: true,
        getProjectKanbanError: action.payload,
      };

    // get project
    //
    //add PROJECT BACKLOG states
    case PROJECT_BACKLOG.ADD_PROJECT_BACKLOG_REQUEST:
      return {
        ...state,
        addProjectBackLogLoading: true,
        addProjectBackLogSuccess: false,
        addProjectBackLogFailure: false,
        addProjectBackLogError: null,
      };
    case PROJECT_BACKLOG.ADD_PROJECT_BACKLOG_SUCCESS:
      // state.projectBackLog = [action.payload, ...state.projectBackLog]
      return {
        ...state,
        addProjectBackLogLoading: false,
        addProjectBackLogSuccess: true,
        addProjectBackLogFailure: false,
        addProjectBackLogError: null,
      };
    case PROJECT_BACKLOG.ADD_PROJECT_BACKLOG_FAILURE:
      return {
        ...state,
        addProjectBackLogLoading: false,
        addProjectBackLogSuccess: false,
        addProjectBackLogFailure: true,
        addProjectBackLogError: action.payload,
      };
    //edit
    case PROJECT_BACKLOG.EDIT_PROJECT_BACKLOG_REQUEST:
      return {
        ...state,
        addProjectBackLogLoading: true,
        addProjectBackLogSuccess: false,
        addProjectBackLogFailure: false,
        addProjectBackLogError: null,
      };
    case PROJECT_BACKLOG.EDIT_PROJECT_BACKLOG_SUCCESS:
      if (action.payload != null) {
        for (let index = 0; index < state.projectBackLog.length; index++) {
          let hasTask =
            action.payload.taskId === state.projectBackLog[index].taskId;
          if (hasTask) {
            state.projectBackLog[index] = action.payload;
          }
        }
      }
      state.projectBackLog = [...state.projectBackLog];
      return {
        ...state,
        addProjectBackLogLoading: false,
        addProjectBackLogSuccess: true,
        addProjectBackLogFailure: false,
        addProjectBackLogError: null,
      };
    case PROJECT_BACKLOG.EDIT_PROJECT_BACKLOG_FAILURE:
      return {
        ...state,
        addProjectBackLogLoading: false,
        addProjectBackLogSuccess: false,
        addProjectBackLogFailure: true,
        addProjectBackLogError: action.payload,
      };
    //edit finished
    //delete task in backlog
    case PROJECT_BACKLOG.DELETE_PROJECT_BACKLOG_REQUEST:
      return {
        ...state,
        deleteProjectBackLogLoading: true,
        deleteProjectBackLogSuccess: false,
        deleteProjectBackLogFailure: false,
        deleteProjectBackLogError: null,
      };
    case PROJECT_BACKLOG.DELETE_PROJECT_BACKLOG_SUCCESS:
      if (action.payload != null) {
        for (let index = 0; index < state.projectBackLog.length; index++) {
          let hasId =
            state.projectBackLog[index].taskId === action.payload.taskId;
          if (hasId) state.projectBackLog.splice(index, 1);
        }
      }
      state.projectBackLog = [...state.projectBackLog];
      return {
        ...state,
        deleteProjectBackLogLoading: false,
        deleteProjectBackLogSuccess: true,
        deleteProjectBackLogFailure: false,
        deleteProjectBackLogError: null,
      };
    case PROJECT_BACKLOG.DELETE_PROJECT_BACKLOG_FAILURE:
      return {
        ...state,
        deleteProjectBackLogLoading: false,
        deleteProjectBackLogSuccess: false,
        deleteProjectBackLogFailure: true,
        deleteProjectBackLogError: action.payload,
      };
    //send task in miletone
    case PROJECT_BACKLOG.ADD_TASK_IN_MILESTONE_REQUEST:
      return {
        ...state,
        addTaskInMilestoneLoading: true,
        addTaskInMilestoneSuccess: false,
        addTaskInMilestoneFailure: false,
        addTaskInMilestoneError: null,
      };
    case PROJECT_BACKLOG.ADD_TASK_IN_MILESTONE_SUCCESS:
      if (action.payload != null) {
        for (let index = 0; index < action.payload.length; index++) {
          for (
            let backlogIndex = 0;
            backlogIndex < state.projectBackLog.length;
            backlogIndex++
          ) {
            let taskInBacklogIndex =
              state.projectBackLog[backlogIndex].taskId ===
              action.payload[index]; //index of found task
            if (taskInBacklogIndex)
              state.projectBackLog.splice(backlogIndex, 1);
          }
        }
      }
      state.projectBackLog = [...state.projectBackLog];
      return {
        ...state,
        addTaskInMilestoneLoading: false,
        addTaskInMilestoneSuccess: true,
        addTaskInMilestoneFailure: false,
        addTaskInMilestoneError: null,
      };
    case PROJECT_BACKLOG.ADD_TASK_IN_MILESTONE_FAILURE:
      return {
        ...state,
        addTaskInMilestoneLoading: false,
        addTaskInMilestoneSuccess: false,
        addTaskInMilestoneFailure: true,
        addTaskInMilestoneError: action.payload,
      };
    default:
      return state;
  }
};
